"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GENERAL_APPLICATION_CHILD_AND_CHILD_TEEN_INTAKE = exports.GENERAL_APPLICATION_CHILD_ADULT_INTAKE = exports.GENERAL_APPLICATION_PARTNER_INTAKE = exports.GENERAL_APPLICATION_APPLICANT_INTAKE = exports.GENERAL_APPLICATION_GETTING_STARTED = void 0;
/* eslint-disable sonarjs/no-duplicate-string */
const question_groups_1 = require("../../groups/question-groups");
const form_1 = require("../../utils/form");
const defaults_1 = require("../defaults");
exports.GENERAL_APPLICATION_GETTING_STARTED = (0, form_1.form)({
    name: "GENERAL_APPLICATION_GETTING_STARTED",
    title: "Getting started",
    content: [
        question_groups_1.QuestionGroup["GENERAL_APPLICATION_GETTING_STARTED_PART1"],
        question_groups_1.QuestionGroup["GENERAL_APPLICATION_GETTING_STARTED_PART2"],
    ],
    id: 50,
});
exports.GENERAL_APPLICATION_APPLICANT_INTAKE = (0, form_1.form)({
    name: "GENERAL_APPLICATION_APPLICANT_INTAKE",
    title: "Intake form",
    content: defaults_1.APPLICANT_DEFAULT_QUESTION_GROUPS,
    id: 51,
});
exports.GENERAL_APPLICATION_PARTNER_INTAKE = (0, form_1.form)({
    name: "GENERAL_APPLICATION_PARTNER_INTAKE",
    title: "Intake form",
    content: defaults_1.PARTNER_DEFAULT_QUESTION_GROUPS,
    id: 52,
});
exports.GENERAL_APPLICATION_CHILD_ADULT_INTAKE = (0, form_1.form)({
    name: "GENERAL_APPLICATION_CHILD_ADULT_INTAKE",
    title: "Intake form",
    content: defaults_1.CHILD_ADULT_DEFAULT_QUESTION_GROUPS,
    id: 53,
});
exports.GENERAL_APPLICATION_CHILD_AND_CHILD_TEEN_INTAKE = (0, form_1.form)({
    name: "GENERAL_APPLICATION_CHILD_AND_CHILD_TEEN_INTAKE",
    title: "Intake form",
    content: defaults_1.CHILD_AND_CHILD_TEEN_DEFAULT_QUESTION_GROUPS,
    id: 54,
});
